const TEST_MEMBER_ID = '31332a93-1b8d-43bd-9c11-342b2ae22cdd';

export function getMemberId() {
  if (window.memberId) {
    return window.memberId;
  }
  let url = new URL(window.location.href);
  let params = new URLSearchParams(url.search);
  let memberId = params.get('memberId');
  return memberId;
}

const isProd = window.location.hostname.includes('carvart.com');

export const ASSETS_API_PROD = 'https://carvart.com/artboardapidev';
export const ASSETS_API_DEV =
  'https://stage.carvart.blackswaninteractive.com/artboardapidev';

export const ASSETS_API = isProd ? ASSETS_API_PROD : ASSETS_API_DEV;

export const API_PROD = 'https://carvart.com/umbraco/api/ArtboardApi';
export const API_DEV =
  'https://stage.carvart.blackswaninteractive.com/umbraco/api/ArtboardApi';

export const API = isProd ? API_PROD : API_DEV;

export async function unFavouriteSwatch({ productKey }) {
  const req = await fetch(`${API}/UnFavouriteSwatch`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      memberId: getMemberId(),
      productKey,
    }),
  });
  if (req.status !== 200) {
    throw new Error(await req.text());
  }
}

export async function saveArtboard({ artboardJson, preview, id }) {
  const req = await fetch(`${API}/SaveArtboard`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      memberId: getMemberId(),
      artboardJson,
      id,
      preview,
    }),
  });
  if (req.status !== 200) {
    throw new Error(await req.text());
  }
}

export async function loadArtboards() {
  const req = await fetch(`${API}/GetArtboards?memberId=${getMemberId()}`);
  if (req.status !== 200) {
    throw new Error(await req.text());
  }
  return await req.json();
}

export async function deleteArtboard(id) {
  const req = await fetch(`${API}/DeleteArtboard`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      memberId: getMemberId(),
      id,
    }),
  });
  if (req.status !== 200) {
    throw new Error(await req.text());
  }
}
